import settingsTemplate from './settings.html';

const DEFAULT_LOCATION_SIZE_TYPE = 'ft2';

export default angular
  .module('main.locations.edit.tabs.settings', [])

  .directive('editLocationSettingsTab', () => {
    return {
      restrict: 'E',
      template: settingsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $filter,
                   $rootScope,
                   utils,
                   config,
                   ToastsService,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;
        const $t = $filter('translate');

        $scope.usagePeriods = config.getConfigByKey('usagePeriods');
        $scope.heatingTypes = config.getConfigByKey('heatingTypes');
        $scope.coolingTypes = config.getConfigByKey('coolingTypes');
        $scope.waterHeaterTypes = config.getConfigByKey('waterHeaterTypes');
        $scope.thermostatTypes = config.getConfigByKey('thermostatTypes');

        $scope.sizeTypes = [
          {
            'name': $t('locations.sizes.ft2'),
            'value': 'ft2'
          }, {
            'name': $t('locations.sizes.m2'),
            'value': 'm2'
          }
        ];

        $scope.isMobileView = $rootScope.isMobileView;

        angular.extend($scope, {
          onGoToLocationStatesButtonClick: onGoToLocationStatesButtonClick,
          onSaveButtonClick: onSaveButtonClick,
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationResource.init()
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function initViewModel() {
          $scope.location = angular.copy($scope.dataProvider.locationResource.value);

          $scope.selectedThermostatId = $scope.location.thermostatType;
          $scope.selectedWaterId = $scope.location.waterHeaterType;
          $scope.selectedPeriodId = $scope.location.usagePeriod;
          $scope.selectedHeatingId = $scope.location.heatingType;
          $scope.selectedCoolingId = $scope.location.coolingType;

          $scope.location.size = $scope.location.size || {};
          $scope.selectedSizeTypeValue = $scope.location.size.unit || DEFAULT_LOCATION_SIZE_TYPE;
        }

        function onGoToLocationStatesButtonClick() {
          $scope.dataProvider.activeTab = 'states';
        }

        function onSaveButtonClick() {
          if ($scope.loading) {
            return;
          }

          $('#form-location-settings').form('validate form');
          if (!$('#form-location-settings').form('is valid')) {
            return;
          }

          let locationInfo = {
            location: {
              storiesNumber: $scope.location.storiesNumber,
              roomsNumber: $scope.location.roomsNumber,
              bathroomsNumber: $scope.location.bathroomsNumber,
              occupantsNumber: $scope.location.occupantsNumber,
              usagePeriod: $scope.selectedPeriodId,
              heatingType: $scope.selectedHeatingId,
              coolingType: $scope.selectedCoolingId,
              waterHeaterType: $scope.selectedWaterId,
              thermostatType: $scope.selectedThermostatId,
              size: {
                unit: $scope.selectedSizeTypeValue || DEFAULT_LOCATION_SIZE_TYPE,
                content: $scope.location.size?.value || 0
                // NOTE server returns { ..., size: {unit: string, value: number} }
                //  but when we update location, server expects { ..., size: {unit: string, content: number|string} }
              }
            }
          };

          $scope.loading = true;
          return $scope.dataProvider.saveLocationInfo(locationInfo)
            .then(() => {
              $scope.loading = false;
              ToastsService.success();
              initViewModel();
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
